// extracted by mini-css-extract-plugin
export default {"card":"yna-z"};